module.exports = __webpack_public_path__ + "static/romania.f3e595a7.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/romania.png
// module id = 448
// module chunks = 168707334958949